import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/** @jsx jsx */


import { jsx } from 'theme-ui';
import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var Horizontal = function Horizontal(_ref) {
  var props = Object.assign({}, _ref);
  var children = React.Children.toArray(props.children);
  return jsx("div", _extends({}, props, {
    sx: {
      display: 'flex',
      alignItems: 'center',
      height: '100%',
      textAlign: 'center'
    }
  }), children.map(function (child, i) {
    return jsx("div", {
      key: child.key,
      sx: {
        width: 100 / children.length + '%'
      }
    }, child);
  }));
};
export default Horizontal;